import { render, staticRenderFns } from "./data27.vue?vue&type=template&id=6d610d1a&scoped=true"
import script from "./data27.vue?vue&type=script&lang=js"
export * from "./data27.vue?vue&type=script&lang=js"
import style1 from "./data27.vue?vue&type=style&index=1&id=6d610d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d610d1a",
  null
  
)

export default component.exports